<template>
  <quick-card title="Subjects">
    <template v-slot:header-actions>
      <v-btn color="primary" icon class="elevation-3">
        <v-icon @click="showD=!showD">add</v-icon>
      </v-btn>
    </template>
    <template v-slot:card-content>
      <v-data-table
        :headers="subjects_headers"
        :items="subjects"
        class="elevation-0"
        :search="search"
        :loading="loading"
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.code?props.item.code:'N/A' }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editsubject(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs6>
                <v-btn flat icon color="pink" @click="deletesubject(props.item,props.index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>

      <m-dialog title="Subject" :show="showD" pers>
        <template v-slot:header-actions>
          <v-btn @click="showD=!showD" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>

            <v-form ref="form">
            <v-flex xs12>
              <v-text-field label="Subject Name*" v-model="subject_model.name" :rules="validRules.required"/>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Subject Code" v-model="subject_model.code" />
            </v-flex>
             <v-flex xs12>
              <v-autocomplete
                label="Assign to Classes:"
                v-model="subject_model.classes"
                :items="classes"
                :multiple="true"
                :chips="true"
                :deletable-chips="true"
                item-text="name"
                item-value="id"
                :clearable="true"
                :rules="validRules.required"
              ></v-autocomplete>

            </v-flex>

             </v-form>

        </template>

        <template v-slot:footer-actions>
          <v-btn style="cursor:pointer" color="success" @click="savesubject()" :loading="loading">save</v-btn>
          <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </m-dialog>
    </template>
  </quick-card>
</template>

<script>
import { mapGetters } from "vuex";
import QuickCard from "../Quickcard";
import Mdialog from "../Modal";
export default {
  name: "subjects",
  components: {
    "quick-card": QuickCard,
    "m-dialog": Mdialog
  },
  data() {
    return {
      showD: false,
      pers: false,
      search: "",
      subject_model:{},
      editedIndex:-1,
      subjects_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn"
        },
        {
          text: "Subject Code",
          align: "center",
          sortable: false,
          value: "code"
        },
        {
          text: "Subject Name",
          align: "center",
          sortable: false,
          value: "name"
        },
        //  {
        //   text: "Status",
        //   align: "center",
        //   sortable: false,
        //   value: "status"
        // },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("subjects/getAll");
    this.$store.dispatch("classes/getAll");

  },
  computed: {
    ...mapGetters({
      subjects: "subjects/SUBJECTS",
      sberrors: "subjects/SUBJECT_ERROR",
      loading: "subjects/SUBJECT_LOADING",

      classes: "classes/CLASSES",
    })
  },
  methods: {
      addsubject() {
      this.$store.dispatch("subjects/add", this.subject_model);

      if (this.sberrors==null) {
        this.subject_model = {};
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Subject saved successfully.",
                title: "Subject",
                modal: false
            })
      }
    },
    deletesubject(subject, index) {
      if (confirm("Are you sure you want to delete this subject?")) {
        this.$store.dispatch("subjects/delete", { subject, index });
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Subject deleted successfully.",
                title: "Subject",
                modal: false
            })
      }
    },

    editsubject(subject) {
      this.editedIndex = this.subjects.indexOf(subject);
      this.subject_model = Object.assign({}, subject);

      //alert(this.editedIndex)

      this.showD = true;
    },
    updatesubject(subject, index) {
       let cls = subject.classes;
      if(cls.length>0){
        if(cls[0].name){
          subject.classes = cls.map(i=>i.id); //changing classes to ids only while ignoring all other data incase it is an array of adcharge objects and not array of ids of adcharge objects. The problem happens when you save without changing any of the classes

        }
      }
      this.$store.dispatch("subjects/update", { index, subject });

      if (this.sberrors==null) {
        this.subject_model = {};
        this.editedIndex = -1;
        this.showD = false;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Subject updated successfully.",
                title: "Subject",
                modal: false
            })
      }
    },
    savesubject() {
     if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing subject info or saving subject info
      if (this.editedIndex > -1) {
        this.updatesubject(this.subject_model, this.editedIndex);
      } else {
        this.addsubject();
      }
    }
  },
    watch:{
    showD(val){
      if(val==false){
        this.subject_model = {};
      }
    },

  }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/subject.vue